export class ProductVariantService {
  validateSelection(
    btn: HTMLButtonElement | null,
    productAdjustPrice: HTMLDivElement | null,
    productStock: HTMLDivElement | null,
    radioButtons: NodeListOf<HTMLInputElement> | null,
  ): void {
    if (
      !btn ||
      !productAdjustPrice ||
      !productStock ||
      !radioButtons ||
      radioButtons.length === 0
    ) {
      return;
    }

    const selectedRadio: HTMLInputElement | null = this.getSelectedRadio(radioButtons);

    if (!selectedRadio) {
      this.handleButtonStates(btn, 0);
      return;
    }

    let available = 1;
    const message: string = selectedRadio.dataset.stock ?? '';
    const price: string = selectedRadio.dataset.price ?? '';
    const saleprice: string = selectedRadio.dataset.saleprice ?? '';

    const selectedValue: string = selectedRadio.value;
    const isPurchasable: number = parseFloat(selectedRadio.dataset.purchasable ?? '0');

    if (!selectedValue || !isPurchasable) {
      available = 0;
    }

    this.handleButtonStates(btn, available);
    this.modifyPrice(radioButtons, productAdjustPrice, price, saleprice);
    this.modifyStock(productStock, message);
  }

  private getSelectedRadio(radioButtons: NodeListOf<HTMLInputElement>): HTMLInputElement | null {
    if (!radioButtons.length) {
      return null;
    }

    for (const radio of radioButtons) {
      if (radio.checked) {
        return radio;
      }
    }

    return null;
  }

  private getSelectedRadioIndex(radioButtons: NodeListOf<HTMLInputElement>): number {
    return Array.from(radioButtons).findIndex((radio) => radio.checked);
  }

  private handleButtonStates(btn: HTMLButtonElement, available: number): void {
    btn.disabled = available < 1;
  }

  private modifyPrice(
    radioButtons: NodeListOf<HTMLInputElement>,
    productPrice: HTMLDivElement,
    price: string,
    saleprice: string,
  ): void {
    const priceOld: HTMLElement | null = productPrice.querySelector('s');
    const priceFrom: HTMLSpanElement | null = productPrice.querySelector('span');
    const priceCurrent: HTMLElement | null = productPrice.querySelector('strong');

    if (priceOld) {
      priceOld.style.display = price ? 'inline-block' : 'none';
      priceOld.innerText = price;
    }

    if (priceFrom) {
      priceFrom.style.display =
        this.getSelectedRadioIndex(radioButtons) > 0 ? 'none' : 'inline-block';
    }

    if (priceCurrent) {
      priceCurrent.innerText = saleprice;
    }
  }

  private modifyStock(productStock: HTMLDivElement, message: string): void {
    if (!message) {
      return;
    }

    productStock.innerHTML = message;
  }
}
